import { Component, Input } from '@angular/core';
import { Flight, Flight2 } from 'src/app/core/models/itinerary.model';

@Component({
  selector: 'app-card-flight',
  templateUrl: './card-flight.component.html',
  styleUrls: ['./card-flight.component.scss']
})
export class CardFlightComponent {
  @Input() flight: Flight | Flight2;
  @Input() cleanColor = false;
}
